import { render, staticRenderFns } from "./RemoveResources.vue?vue&type=template&id=386c313e&scoped=true&"
import script from "./RemoveResources.vue?vue&type=script&lang=js&"
export * from "./RemoveResources.vue?vue&type=script&lang=js&"
import style0 from "./RemoveResources.vue?vue&type=style&index=0&id=386c313e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386c313e",
  null
  
)

export default component.exports